<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2.97222 0C1.33071 0 0 1.33071 0 2.97222V10.75C0 12.3915 1.33071 13.7222 2.97222 13.7222H10.75C12.3915 13.7222 13.7222 12.3915 13.7222 10.75V2.97222C13.7222 1.33071 12.3915 0 10.75 0H2.97222ZM1.5 2.97222C1.5 2.15914 2.15914 1.5 2.97222 1.5H10.75C11.5631 1.5 12.2222 2.15914 12.2222 2.97222V10.75C12.2222 11.5631 11.5631 12.2222 10.75 12.2222H2.97222C2.15914 12.2222 1.5 11.5631 1.5 10.75V2.97222Z"
        />
        <path
            d="M15.7539 4.10488C15.37 3.94933 14.9327 4.13444 14.7771 4.51834C14.6216 4.90224 14.8067 5.33955 15.1906 5.4951C15.7319 5.71443 16.1111 6.24384 16.1111 6.8611V14.6389C16.1111 15.4524 15.4524 16.1111 14.6389 16.1111H6.8611C6.24473 16.1111 5.71434 15.7317 5.4951 15.1906C5.33955 14.8067 4.90224 14.6216 4.51834 14.7771C4.13444 14.9327 3.94933 15.37 4.10488 15.7539C4.54563 16.8416 5.61302 17.6111 6.8611 17.6111H14.6389C16.2809 17.6111 17.6111 16.2809 17.6111 14.6389V6.8611C17.6111 5.61169 16.8414 4.54555 15.7539 4.10488Z"
        />
    </svg>
</template>
